// PaymentCancelled.jsx
import React from "react";
import styled from "styled-components";
import TopNavbar from "../Nav/TopNavbar";
import Footer from "./Footer";

export default function PaymentCancelled() {
  return (
    <>
    <TopNavbar returnTo={true}/>
    <br/>
   <br/>
   <br/>
    <CancelWrapper>
      <h2>⚠️ Payment Cancelled</h2>
      <p>Your payment was cancelled. You can resume checkout anytime from your order email or dashboard.</p>
    </CancelWrapper>

    <Footer/>
    </>
  );
}

const CancelWrapper = styled.div`
  padding: 60px 20px;
  max-width: 600px;
  margin: auto;
  text-align: center;
  h2 {
    color: orange;
    margin-bottom: 20px;
  }
`;
